import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { InquiryAppointmentComponent } from './inquiry-appointment.component';

const routes: Routes = [
  {
      path: '',
      component: InquiryAppointmentComponent,
      canDeactivate:[DeactivateGuard]
  },
  {
      path: 'confirm',
      component: ConfirmInfoComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InquiryAppointmentRoutingModule { }
